<div class="full-page-container">
  <div class="container">
    <a class="back-btn text-primary cursor-pointer d-none d-lg-flex align-items-center justify-content-center" (click)="goBack()">
      <span class="material-symbols-outlined ms-2 text-white"> arrow_back_ios </span>
    </a>

    <div class="d-block d-lg-none">
      <fgb-page-header [pageTitle]="'wallet.page.title'" [showBalance]="false" [showQr]="false"></fgb-page-header>
    </div>

    <div class="pt-4 pt-lg-0">
      <fgbcl-lottos-wallet-details [lottoId]="id"></fgbcl-lottos-wallet-details>
    </div>
  </div>
</div>
